import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '2rem',
      textAlign: 'center',
    }}
  >
    <i className="fas fa-compass" style={{ fontSize: '4rem', color: '#1a4f8c', marginBottom: '1rem' }} />
    <h1 style={{ color: '#2c3e50', marginBottom: '0.5rem' }}>404 — Page Not Found</h1>
    <p style={{ color: '#7f8c8d', marginBottom: '1.5rem' }}>
      The page you&apos;re looking for doesn&apos;t exist or has moved.
    </p>
    <Link
      to="/dashboard"
      style={{
        background: '#1a4f8c',
        color: '#fff',
        padding: '0.6rem 1.2rem',
        borderRadius: '6px',
        textDecoration: 'none',
        fontWeight: 500,
      }}
    >
      Back to Dashboard
    </Link>
  </div>
);

export default NotFoundPage;
